// @core/api/endpoints/team/list_role_schedules.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRoleSchedulesResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List role schedules
 * Returns a paginated list of role schedules. Supports filtering and sorting.
 */
export async function ListRoleSchedules(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRoleSchedulesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListRoleSchedulesResponse>(requestPath, { ...requestOptions, params });
}
